<div class="pt-5 pb-4 position-relative"></div>
<section class="content-header position-relative">
  <div *ngIf="!isLoading && boat" class="container-fluid">
    <div class="row mb-2">
      <div class="col-md-12">
        <nav
          style="
            --bs-breadcrumb-divider: url(
              &#34;data:image/svg + xml,
              %3Csvgxmlns=&quot;http://www.w3.org/2000/svg&quot;width=&quot;8&quot;height=&quot;8&quot;%3E%3Cpathd=&quot;M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z&quot;fill=&quot;%236c757d&quot;/%3E%3C/svg%3E&#34;
            );
          "
          aria-label="breadcrumb"
        >
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a class="nn" routerLink="/home">Home</a>
            </li>
            <li class="breadcrumb-item">
              <a class="nn" [routerLink]="'/' + link_ktg">{{ link_tampil }}</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ boat.nama_kapal }}
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="card d-none d-md-block">
      <div class="card-header">
        <div class="row">
          <div class="col-md-6">
            <h3>{{ boat.nama_kapal }}</h3>
            <span
              *ngIf="boat.featured"
              class="badge bg-success"
              style="margin-right: 10px !important"
            >
              Featured
            </span>

            <span class="badge bg-secondary">
              {{ boat.boat_kategori }}
            </span>
            <span
              *ngFor="let tag of boat.activity_tags"
              class="badge bg-info text-dark ms-2"
            >
              {{ tag | activityTagLabel }}
            </span>
          </div>
          <div class="col-md-6 text-end">
            <h3>
              <span style="font-weight: 600"
                >IDR {{ boat.harga | number }}/Pax</span
              >
            </h3>
          </div>
        </div>
      </div>
      <div class="card-body">
        <!-- Loading spinner -->
        <div class="text-center my-5" *ngIf="isLoading">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div class="alert alert-danger" *ngIf="error">
          {{ error }}
        </div>

        <!-- Gallery Section -->
        <div
          class="row g-2"
          *ngIf="boat.ms_gambarkapals && boat.ms_gambarkapals.length > 0"
        >
          <!-- Main large image -->
          <div class="col-md-8 mb-4">
            <div class="position-relative main-image-container">
              <img
                [src]="getImageUrl(boat.ms_gambarkapals[selectedImageIndex].gambar)"
                class="img-fluid w-100 rounded shadow main-image"
                [alt]="boat.nama_kapal"
                (click)="openCarouselModal(selectedImageIndex)"
                style="cursor: pointer"
              />
            </div>
          </div>

          <!-- Side gallery -->
          <div class="col-md-4">
            <div class="row g-2">
              <!-- First side image -->
              <div class="col-12" *ngIf="boat.ms_gambarkapals.length > 1">
                <div class="position-relative side-image-container">
                  <img
                    [src]="getImageUrl(boat.ms_gambarkapals[1].gambar)"
                    class="img-fluid w-100 rounded shadow cursor-pointer side-image"
                    [alt]="boat.nama_kapal"
                    (click)="openCarouselModal(1)"
                    style="cursor: pointer"
                  />
                </div>
              </div>

              <!-- Second side image or View More button -->
              <div class="col-12">
                <!-- Show second image if it exists -->
                <div
                  class="position-relative side-image-container"
                  *ngIf="boat.ms_gambarkapals.length > 2"
                >
                  <img
                    [src]="getImageUrl(boat.ms_gambarkapals[2].gambar)"
                    class="img-fluid w-100 rounded shadow cursor-pointer side-image"
                    [alt]="boat.nama_kapal"
                    (click)="openCarouselModal(2)"
                    style="cursor: pointer"
                  />
                  <!-- Overlay with View More button if there are more photos -->
                  <div
                    *ngIf="getRemainingPhotosCount() > 0"
                    class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                    (click)="openCarouselModal(2)"
                  >
                    <span
                      class="text-white shadow h3"
                      style="
                        cursor: pointer;
                        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
                      "
                    >
                      {{ getRemainingPhotosCount() }} More
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center">
          <p
            *ngIf="!boat.ms_gambarkapals || boat.ms_gambarkapals.length === 0"
            class="text-muted"
          >
            No images uploaded yet
          </p>
        </div>

        <div class="row g-2">
          <div class="col-sm-3 text-center">
            <strong>{{ boat.trip_kategori }} </strong>
            <br /><span>Trip Category</span>
          </div>

          <div class="col-sm-3 text-center">
            <i class="fa fa-calendar p-1"></i>
            <strong>{{ boat.durasi }} </strong>
          </div>

          <div class="col-sm-3 text-center">
            <i class="fa fa-bed p-1"></i> <strong>{{ boat.kabin }} </strong>
            <br /><span>Cabins </span>
          </div>

          <div class="col-sm-3 text-center">
            <i class="fa fa-users p-1"></i>
            <strong>{{ boat.jumlah_tamu }}</strong> <br /><span> Guests </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Layar hp -->
    <div class="card p-0 d-md-none">
      <div class="card-body p-0">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3" *ngIf="boat.ms_gambarkapals.length > 0">
              <div class="ctr">
                <img
                  [src]="getImageUrl(boat.ms_gambarkapals[0].gambar)"
                  class="img-fluid w-100 shadow cursor-pointer side-image"
                  [alt]="boat.nama_kapal"
                  (click)="openCarouselModal(0)"
                  style="cursor: pointer"
                />

                <!-- Overlay with View More button if there are more photos -->
                <div
                  *ngIf="getRemainingPhotosCountmobile() > 0"
                  class="bottomright"
                  (click)="openCarouselModal(0)"
                >
                  <span
                    class="text-white shadow h6"
                    style="
                      cursor: pointer;
                      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
                    "
                  >
                    {{ getRemainingPhotosCountmobile() }} More
                  </span>
                </div>
              </div>
            </div>

            <div class="text-center">
              <p
                *ngIf="
                  !boat.ms_gambarkapals || boat.ms_gambarkapals.length === 0
                "
                class="text-muted"
              >
                No images uploaded yet
              </p>
            </div>

            <div class="p-3">
              <span
                *ngIf="boat.featured"
                class="badge bg-success mb-2"
                style="margin-right: 10px !important"
              >
                Featured
              </span>

              <span class="badge bg-secondary mb-2">
                {{ boat.boat_kategori }}
              </span>
              <span
                *ngFor="let tag of boat.activity_tags"
                class="badge bg-info text-dark mb-2 ms-2"
              >
                {{ tag | activityTagLabel }}
              </span>

              <h4>{{ boat.nama_kapal }}</h4>
              <h5>
                <strong>IDR {{ boat.harga | number }}/Pax</strong>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ----------------------------------------------------- -->

    <div *ngIf="boat.ms_accomodations.length == 0" class="row">
      <div class="col-lg-12">
        <!-- Detail -->
        <div class="card mt-3">
          <div class="card-body">
            <!-- Header with update info -->
            <div class="row g-3 mb-3 pb-4 border-bottom">
              <div class="col-md-6">
                <h5 class="card-judul mb-0">Details</h5>
              </div>
              <div class="col-md-6">
                <div class="d-none d-md-block text-end">
                  <small class="text-muted">
                    <i class="fas fa-clock me-1"></i>
                    Updated on {{ boat.updatedAt | date: "MMMM d, yyyy" }} at
                    {{ boat.updatedAt | date: "h:mm a" }}
                  </small>
                </div>

                <div class="d-md-none text-start">
                  <small class="text-muted">
                    <i class="fas fa-clock me-1"></i>
                    Updated on {{ boat.updatedAt | date: "MMMM d, yyyy" }} at
                    {{ boat.updatedAt | date: "h:mm a" }}
                  </small>
                </div>
              </div>
            </div>

            <!-- Desktop View (≥768px) -->
            <div class="detail-wrap">
              <div class="row g-3 m-3">
                <!-- Left Column -->
                <div class="col-md-6">
                  <ul class="list-unstyled mb-0">
                    <li class="mb-3 border-bottom">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="detail-label"><strong>Price:</strong></div>
                        <div class="detail-value">
                          IDR {{ boat.harga | number }}/Pax
                        </div>
                      </div>
                    </li>
                    <li class="mb-3 border-bottom">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="detail-label"><strong>Cabins:</strong></div>
                        <div class="detail-value">{{ boat.kabin }}</div>
                      </div>
                    </li>
                    <li class="border-bottom">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="detail-label"><strong>Guests:</strong></div>
                        <div class="detail-value">{{ boat.jumlah_tamu }}</div>
                      </div>
                    </li>
                  </ul>
                </div>

                <!-- Right Column -->
                <div class="col-md-6">
                  <ul class="list-unstyled mb-0">
                    <li class="mb-3 border-bottom">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="detail-label">
                          <strong>Trip Category:</strong>
                        </div>
                        <div class="detail-value">{{ boat.trip_kategori }}</div>
                      </div>
                    </li>
                    <li class="border-bottom">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="detail-label">
                          <strong>Boat Category:</strong>
                        </div>
                        <div class="detail-value">{{ boat.boat_kategori }}</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- //---------------------------------------------------------------------- -->

        <!-- Destination -->

        <div class="card mt-3">
          <div class="card-body">
            <!-- Header with update info -->
            <div class="row g-3 mb-3 pb-4 border-bottom">
              <div class="col-md-12">
                <h5 class="card-judul mb-0">Destination</h5>
              </div>
            </div>

            <div class="row g-3 mb-3 mt-3">
              <!-- Left Column -->
              <div class="col-md-6">
                <ul class="list-unstyled mb-0">
                  <li class="mb-3 border-bottom">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div class="detail-label">
                        <strong>Destination(s) :</strong>
                      </div>
                      <div class="detail-value">{{ tujuans }}</div>
                    </div>
                  </li>
                </ul>
              </div>

              <!-- Right Column -->
              <div class="col-md-6">
                <ul class="list-unstyled mb-0">
                  <li class="mb-3 border-bottom">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div class="detail-label"><strong>Country:</strong></div>
                      <div class="detail-value">{{ boat.negara }}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- ------------------------------------------------------------------- -->
        <div class="card mt-3">
          <div class="card-body">
            <!-- Header with update info -->

            <!-- Keterangan -->
            <div class="row g-3 mb-3 pb-4 border-bottom">
              <div class="col-md-12">
                <h5 class="card-judul mb-0">Description</h5>
              </div>
            </div>
            <div class="row mb-3 pb-4">
              <div class="col-md-12">
                <div
                  [innerHTML]="keterangans || 'No description available'"
                ></div>
              </div>
            </div>

            <!-- Itinerary -->

            <div *ngIf="boat">
              <app-itinerary-boat
                [boatId]="boat.id"
                [boatSlug]="boat.slug"
                [boatItinerary]="boat.ms_itineraries"
              >
              </app-itinerary-boat>
            </div>

            <!-- ------------------------------------------------------------------- -->

            <!-- Sevices -->
            <div *ngIf="boat">
              <app-sevices-boat
                [boatId]="boat.id"
                [boatSlug]="boat.slug"
                [boatServices]="boat.ms_services"
              >
              </app-sevices-boat>
            </div>

            <!-- ------------------------------------------------------------------- -->
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="boat.ms_accomodations.length > 0" class="row">
      <div class="col-lg-8">
        <!-- Detail -->
        <div class="card mt-3">
          <div class="card-body">
            <!-- Header with update info -->
            <div class="row g-3 mb-3 pb-4 border-bottom">
              <div class="col-md-6">
                <h5 class="card-judul mb-0">Details</h5>
              </div>
              <div class="col-md-6">
                <div class="d-none d-md-block text-end">
                  <small class="text-muted">
                    <i class="fas fa-clock me-1"></i>
                    Updated on {{ boat.updatedAt | date: "MMMM d, yyyy" }} at
                    {{ boat.updatedAt | date: "h:mm a" }}
                  </small>
                </div>

                <div class="d-md-none text-start">
                  <small class="text-muted">
                    <i class="fas fa-clock me-1"></i>
                    Updated on {{ boat.updatedAt | date: "MMMM d, yyyy" }} at
                    {{ boat.updatedAt | date: "h:mm a" }}
                  </small>
                </div>
              </div>
            </div>

            <!-- Desktop View (≥768px) -->
            <div class="detail-wrap">
              <div class="row g-3 m-3">
                <!-- Left Column -->
                <div class="col-md-6">
                  <ul class="list-unstyled mb-0">
                    <li class="mb-3 border-bottom">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="detail-label"><strong>Price:</strong></div>
                        <div class="detail-value">
                          IDR {{ boat.harga | number }}/Pax
                        </div>
                      </div>
                    </li>
                    <li class="mb-3 border-bottom">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="detail-label"><strong>Cabins:</strong></div>
                        <div class="detail-value">{{ boat.kabin }}</div>
                      </div>
                    </li>
                    <li class="border-bottom">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="detail-label"><strong>Guests:</strong></div>
                        <div class="detail-value">{{ boat.jumlah_tamu }}</div>
                      </div>
                    </li>
                  </ul>
                </div>

                <!-- Right Column -->
                <div class="col-md-6">
                  <ul class="list-unstyled mb-0">
                    <li class="mb-3 border-bottom">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="detail-label">
                          <strong>Trip Category:</strong>
                        </div>
                        <div class="detail-value">{{ boat.trip_kategori }}</div>
                      </div>
                    </li>
                    <li class="border-bottom">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="detail-label">
                          <strong>Boat Category:</strong>
                        </div>
                        <div class="detail-value">{{ boat.boat_kategori }}</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- //---------------------------------------------------------------------- -->

        <!-- Destination -->

        <div class="card mt-3">
          <div class="card-body">
            <!-- Header with update info -->
            <div class="row g-3 mb-3 pb-4 border-bottom">
              <div class="col-md-12">
                <h5 class="card-judul mb-0">Destination</h5>
              </div>
            </div>

            <div class="row g-3 mb-3 mt-3">
              <!-- Left Column -->
              <div class="col-md-6">
                <ul class="list-unstyled mb-0">
                  <li class="mb-3 border-bottom">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div class="detail-label">
                        <strong>Destination(s) :</strong>
                      </div>
                      <div class="detail-value">{{ tujuans }}</div>
                    </div>
                  </li>
                </ul>
              </div>

              <!-- Right Column -->
              <div class="col-md-6">
                <ul class="list-unstyled mb-0">
                  <li class="mb-3 border-bottom">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div class="detail-label"><strong>Country:</strong></div>
                      <div class="detail-value">{{ boat.negara }}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- ------------------------------------------------------------------- -->
        <div class="card mt-3">
          <div class="card-body">
            <!-- Header with update info -->

            <!-- Keterangan -->
            <div class="row g-3 mb-3 pb-4 border-bottom">
              <div class="col-md-12">
                <h5 class="card-judul mb-0">Description</h5>
              </div>
            </div>
            <div class="row mb-3 pb-4">
              <div class="col-md-12">
                <div
                  [innerHTML]="keterangans || 'No description available'"
                ></div>
              </div>
            </div>

            <!-- Itinerary -->

            <div *ngIf="boat">
              <app-itinerary-boat
                [boatId]="boat.id"
                [boatSlug]="boat.slug"
                [boatItinerary]="boat.ms_itineraries"
              >
              </app-itinerary-boat>
            </div>

            <!-- ------------------------------------------------------------------- -->

            <!-- Sevices -->
            <div *ngIf="boat">
              <app-sevices-boat
                [boatId]="boat.id"
                [boatSlug]="boat.slug"
                [boatServices]="boat.ms_services"
              >
              </app-sevices-boat>
            </div>

            <!-- ------------------------------------------------------------------- -->
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="sticky-top" style="z-index: 0">
          <div class="card mt-3 shadow-sm">
            <div class="card-body book_s">
              <!-- Header with update info -->
              <div
                class="row g-1 mb-3 pb-3 border-bottom d-flex align-items-center"
              >
                <div class="col-md-8">
                  <strong class="fs-6">
                    <ng-container *ngIf="value > 1; else hargaAwal">
                      From IDR {{ formattedTotal | number }}
                    </ng-container>
                    <ng-template #hargaAwal>
                      From IDR {{ getHargaAwalPerOrang() | number }}
                    </ng-template>
                    <span *ngIf="value === 0">/ person</span>
                  </strong>
                </div>
                <div class="col-md-4 text-end">
                  <span
                    class="text-muted text-decoration-underline"
                    style="cursor: pointer"
                    (click)="openModalPrice()"
                    >show prices</span
                  >
                </div>
              </div>

              <!-- Booking Form -->
              <div class="row g-1 booking-form">
                <div class="col-md-12">
                  <form
                    [formGroup]="bookForm"
                    (ngSubmit)="pesan()"
                    autocomplete="off"
                  >
                    <!-- Guests -->
                    <div class="mb-3">
                      <div class="input-group">
                        <div
                          class="form-control"
                          style="border-right: 0px !important"
                          (click)="openModaltamu()"
                          [ngClass]="{
                            'text-dark': jumTamu,
                            'text-secondary': !jumTamu,
                          }"
                        >
                          {{ jumTamu || "Guests" }}
                        </div>
                        <span class="input-group-text">
                          <i
                            class="fa fa-chevron-down text-secondary"
                            style="cursor: pointer"
                            aria-hidden="true"
                            (click)="openModaltamu()"
                          >
                          </i>
                        </span>
                      </div>

                      <input
                        type="text"
                        class="form-control"
                        id="tamu"
                        formControlName="tamu"
                        [ngClass]="{
                          'is-invalid':
                            submitted && bookForm.get('tamu')?.invalid,
                        }"
                        autocomplete="tamu"
                        style="display: none"
                      />

                      <div class="text-danger" *ngIf="submitted">
                        <div *ngIf="hasError(bookForm, 'tamu', 'required')">
                          Please enter number of person
                        </div>
                      </div>
                    </div>

                    <!-- Start Date -->
                    <div class="mb-3">
                      <div class="input-group">
                        <!-- <div class="form-control" data-bs-toggle="modal" data-bs-target="#calendarModal">Start Date</div> -->
                        <div
                          class="form-control"
                          style="border-right: 0px !important"
                          #datepicker
                          (click)="openModal()"
                          [ngClass]="{
                            'text-dark': selectedDate,
                            'text-secondary': !selectedDate,
                          }"
                        >
                          {{ selectedDate || "Start Date" }}
                        </div>

                        <span class="input-group-text">
                          <i
                            class="fa fa-chevron-down text-secondary"
                            style="cursor: pointer"
                            aria-hidden="true"
                            (click)="openModal()"
                          >
                          </i>
                        </span>
                      </div>

                      <input
                        type="text"
                        class="form-control"
                        id="tgl"
                        formControlName="tgl"
                        [ngClass]="{
                          'is-invalid':
                            submitted && bookForm.get('tgl')?.invalid,
                        }"
                        autocomplete="tgl"
                        style="display: none"
                      />

                      <div class="text-danger" *ngIf="submitted">
                        <div *ngIf="hasError(bookForm, 'tgl', 'required')">
                          Please select start date
                        </div>
                      </div>
                    </div>

                    <!-- Accomodation -->
                    <div class="mb-3">
                      <div class="input-group">
                        <div
                          class="form-control"
                          style="border-right: 0px !important"
                          (click)="openModalAcc()"
                          [ngClass]="{
                            'text-dark': tripAcc,
                            'text-secondary': !tripAcc,
                          }"
                        >
                          {{ tripAcc || "Accommodation" }}
                        </div>
                        <span class="input-group-text">
                          <i
                            class="fa fa-chevron-down text-secondary"
                            style="cursor: pointer"
                            aria-hidden="true"
                            (click)="openModalAcc()"
                          ></i>
                        </span>
                      </div>

                      <input
                        type="text"
                        class="form-control"
                        id="accomodation"
                        formControlName="accomodation"
                        [ngClass]="{
                          'is-invalid':
                            submitted && bookForm.get('accomodation')?.invalid,
                        }"
                        autocomplete="accomodation"
                        style="display: none"
                      />

                      <div class="text-danger" *ngIf="submitted">
                        <div
                          *ngIf="hasError(bookForm, 'accomodation', 'required')"
                        >
                          Please select trip accomodation
                        </div>
                      </div>
                    </div>

                    <!-- Total -->
                    <div>
                      <input
                        type="text"
                        class="form-control"
                        id="total"
                        formControlName="total"
                        [ngClass]="{
                          'is-invalid':
                            submitted && bookForm.get('total')?.invalid,
                        }"
                        autocomplete="total"
                        style="display: none"
                      />
                      <div class="text-danger" *ngIf="submitted">
                        <div
                          *ngIf="hasError(bookForm, 'total', 'required')"
                        ></div>
                      </div>
                    </div>

                    <!-- Reserve Button -->
                    <div class="mb-3 mt-4 text-center">
                      <button type="submit" class="btn btn-primary">
                        Reserve
                      </button>
                    </div>
                    <div class="mb-3 text-center">
                      <span class="text-muted small"
                        >You won't be charged yet</span
                      >
                    </div>

                    <div *ngIf="totPrice > 0">
                      <div class="w-100">
                        <div
                          *ngFor="let room of selectedAccommodationsList"
                          class="d-flex justify-content-between align-items-center"
                        >
                          <span>{{ room.name }}</span>
                          <span class="price"
                            >IDR {{ room.price | number }}</span
                          >
                        </div>
                      </div>

                      <hr />

                      <div class="total-price">
                        <div class="w-100">
                          <div
                            class="d-flex justify-content-between align-items-center"
                          >
                            <span><strong>Total</strong> </span>
                            <span>IDR {{ totPrice | number }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="d-flex justify-content-center align-items-center"
    style="min-height: 300px"
    *ngIf="isLoading"
  >
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</section>

<!-- Guest Modal -->

<div class="modal fade" id="guestModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Who’s coming?</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-8 text-start">
            <span><strong>Persons</strong></span>
          </div>
          <div class="col-md-4 text-end">
            <div class="wrapper">
              <button
                class="plusminus"
                (click)="decrement()"
                [disabled]="isDecrementDisabled()"
              >
                <i class="fas fa-minus"></i>
              </button>
              <input
                type="number"
                class="num form-control"
                [(ngModel)]="value"
                [min]="min"
                [max]="max"
                (change)="validateValue()"
                (paste)="preventPaste($event)"
                (keypress)="preventKeypress($event)"
              />
              <button
                class="plusminus"
                (click)="increment()"
                [disabled]="isIncrementDisabled()"
              >
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="applyTamu()">
          Select
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Start Date -->

<div class="modal fade" id="dateModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Choose Start Date | Open Trip</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
        ></button>
      </div>
      <div class="modal-body">
        <div class="calendar-container text-center mb-3">
          <input type="text" #flatpickrEl class="d-none" />
        </div>
        <div *ngIf="selectedDate" class="text-center mt-2">
          <hr
            style="margin-left: 9rem !important; margin-right: 9rem !important"
          />
          <button
            class="btn btn-link text-secondary"
            (click)="clearSelection()"
          >
            Clear Selection
          </button>
        </div>
      </div>
      <div class="modal-footer">
        <div class="d-flex justify-content-between align-items-center w-100">
          <div>
            <div *ngIf="totalPrice">
              <strong>Total: {{ "IDR " + (totalPrice | number) }}</strong>
            </div>
            <div class="text-muted small">{{ formattedDate }}</div>
          </div>
          <button type="button" class="btn btn-primary" (click)="applyDate()">
            Select
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Accomodation Modal -->
<div class="modal fade" id="accModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Choose Accommodation</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="mb-3">
            <strong>Pick your favorite rooms</strong>
          </div>

          <div
            *ngFor="let acc of accomodations; let i = index"
            class="col-md-12 mb-3"
          >
            <div
              class="card"
              style="border: solid 1px var(--bs-border-color-translucent)"
              [style.opacity]="isCabinUnavailable(acc) ? '0.5' : '1'"
            >
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <img
                    *ngIf="acc.images?.length > 0"
                    [src]="getAccommodationUrl(acc.images[0].image_url)"
                    class="rounded"
                    width="100"
                    height="100"
                    alt="Room Image"
                    (error)="$any($event.target).style.display = 'none'"
                  />
                  <div
                    *ngIf="!acc.images?.length"
                    class="rounded d-flex align-items-center justify-content-center bg-light text-muted"
                    style="width: 100px; height: 100px"
                  >
                    <i class="fas fa-image fa-2x"></i>
                  </div>

                  <div class="ms-3 flex-grow-1">
                    <h5 style="color: var(--warna-2)">{{ acc.name }}</h5>
                    <p>{{ tipe_kabin(acc.cabin_type) }}</p>

                    <p class="mb-0 text-muted">{{ getSleepInfo(acc) }}</p>
                    <p id="hrg_{{ acc.id }}" *ngIf="!acc.isSelected">
                      <strong>IDR {{ acc.price | number }}</strong
                      >/{{ acc.price_type }}
                    </p>

                    <p id="hrg_total{{ acc.id }}" *ngIf="acc.isSelected">
                      <strong
                        >Total: IDR {{ getTotalPrice(acc) | number }}</strong
                      >
                    </p>
                  </div>
                  <div>
                    <div class="text-end mb-4">
                      <span
                        class="text-danger"
                        *ngIf="
                          acc.cabin_type === 'shared' &&
                          !isCabinUnavailable(acc)
                        "
                      >
                        {{
                          getCabinAvailableSpots(acc) !== null
                            ? getCabinAvailableSpots(acc)
                            : getTotalBeds(acc)
                        }}
                        {{ acc.price_type }} left</span
                      >
                      <span
                        class="text-danger"
                        *ngIf="
                          acc.cabin_type === 'private' &&
                          !isCabinUnavailable(acc)
                        "
                      >
                        1 {{ acc.price_type }} left</span
                      >
                      <span
                        class="badge bg-secondary"
                        *ngIf="isCabinUnavailable(acc)"
                      >
                        Unavailable</span
                      >
                    </div>
                    <div>
                      <span
                        *ngIf="acc.isSelected && !isCabinUnavailable(acc)"
                        class="link-buatan"
                        (click)="show_pil(acc)"
                        >remove</span
                      >
                      <button
                        *ngIf="!acc.isSelected"
                        class="btn btn-primary ms-3"
                        [disabled]="isCabinUnavailable(acc)"
                        (click)="show_pil(acc)"
                      >
                        {{ isCabinUnavailable(acc) ? "Unavailable" : "Select" }}
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="acc.isSelected && acc.cabin_type === 'shared'"
                  class="d-flex align-items-center mt-2"
                >
                  <div class="ms-3 flex-grow-1">
                    <p>Number of Beds</p>
                  </div>
                  <div class="text-end">
                    <div class="wrapper">
                      <button
                        class="plusminus"
                        (click)="dec_bed(acc)"
                        [disabled]="isDecBedDisabled(acc)"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                      <input
                        type="number"
                        class="num form-control"
                        [(ngModel)]="acc.valBed"
                        [min]="min_bed(acc.id)"
                        [max]="getTotalBeds(acc)"
                        (change)="validateValueBed(acc)"
                        (paste)="preventPaste($event)"
                        (keypress)="preventKeypress($event)"
                      />
                      <button
                        class="plusminus"
                        (click)="inc_bed(acc)"
                        [disabled]="isIncBedDisabled(acc)"
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  *ngIf="acc.isSelected && acc.cabin_type === 'private'"
                  class="mt-2"
                >
                  <div class="d-flex align-items-center">
                    <div class="ms-3 flex-grow-1">
                      <p>Number of Rooms</p>
                    </div>
                    <div class="text-end">
                      <div class="wrapper">
                        <button
                          class="plusminus"
                          (click)="dec_room()"
                          [disabled]="isDecRoomDisabled()"
                        >
                          <i class="fas fa-minus"></i>
                        </button>
                        <input
                          type="number"
                          class="num form-control"
                          [(ngModel)]="acc.valRoom"
                          [min]="1"
                          [max]="1"
                          (paste)="preventPaste($event)"
                          (keypress)="preventKeypress($event)"
                        />
                        <button
                          class="plusminus"
                          (click)="inc_room()"
                          [disabled]="isIncRoomDisabled()"
                        >
                          <i class="fas fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="ms-3 flex-grow-1">
                      <p>Guests Per Room</p>

                      <!-- <div class="mt-2 text-end">
                              <small class="text-muted">
                                Total Price: <strong>IDR {{ acc.totalPrice | number }}</strong>
                              </small>
                          </div> -->
                    </div>
                    <div class="text-end">
                      <div class="wrapper">
                        <button
                          class="plusminus"
                          (click)="dec_guests(acc)"
                          [disabled]="isDecGuestsDisabled(acc)"
                        >
                          <i class="fas fa-minus"></i>
                        </button>
                        <input
                          type="number"
                          class="num form-control"
                          [(ngModel)]="acc.valGuests"
                          [min]="min_guests()"
                          [max]="getMaxGuests(acc)"
                          (change)="validateValueGuests(acc)"
                          (paste)="preventPaste($event)"
                          (keypress)="preventKeypress($event)"
                        />
                        <button
                          class="plusminus"
                          (click)="inc_guests(acc)"
                          [disabled]="isIncGuestsDisabled(acc)"
                        >
                          <i class="fas fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="w-100">
          <div class="d-flex justify-content-between align-items-center">
            <!-- Total harga -->
            <div *ngIf="getTotal()">
              <p class="fs-5 fw-bold mb-2">
                Total:
                <span class="text-dark">IDR {{ getTotal() | number }}</span>
              </p>
            </div>

            <span class="text-danger fw-semibold mb-1" *ngIf="totTamu > 0">
              You still need to fit
              <span class="fw-bold">{{ totTamu }}</span> more people
            </span>
          </div>
        </div>

        <!-- List akomodasi yang dipilih -->
        <div class="w-100">
          <ng-container *ngFor="let acc of accomodations">
            <div
              class="d-flex justify-content-between align-items-center"
              *ngIf="acc.isSelected"
            >
              <span>{{ acc.valBed || acc.valRoom }} x {{ acc.name }}</span>
              <span class="link-buatan" (click)="show_pil(acc)">remove</span>
            </div>
          </ng-container>
        </div>

        <!-- Tombol Pilih -->
        <button
          class="btn btn-primary mt-3 fw-semibold"
          (click)="applyAccomodation()"
        >
          Select
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Gallery Modal -->
<div
  *ngIf="showCarouselModal"
  class="modal fade show d-block"
  tabindex="-1"
  role="dialog"
>
  <div class="modal-dialog modal-fullscreen" style="margin: 0 auto !important">
    <div class="modal-content bg-dark">
      <!-- Close button in header -->
      <div
        class="modal-header border-0 mb-2 mt-2 py-2 px-3 d-flex justify-content-between align-items-center"
      >
        <h5 class="modal-title text-white mb-0">
          {{ boat?.nama_kapal }} Gallery
        </h5>
        <button
          type="button"
          class="btn-close btn-close-white"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="closeCarouselModal()"
        ></button>
      </div>

      <div class="modal-body p-0">
        <div class="container-fluid">
          <!-- Main Carousel -->
          <ngx-slick-carousel
            #slickModal="slick-carousel"
            class="carousel"
            [config]="slickConfig"
            (afterChange)="onSlideChange($event)"
          >
            <div
              ngxSlickItem
              *ngFor="let image of boat?.ms_gambarkapals; let i = index"
              class="slide-item"
            >
              <img
                [src]="getImageUrl(image.gambar)"
                [alt]="boat?.nama_kapal"
                class="img-fluid"
              />
            </div>
          </ngx-slick-carousel>

          <!-- Thumbnails -->
          <div class="row mt-3 d-none d-md-block">
            <div class="col-12">
              <div
                class="d-flex justify-content-center gap-2 overflow-auto py-2 px-4 thumbnails-container"
              >
                <div
                  *ngFor="let image of boat?.ms_gambarkapals; let i = index"
                  class="position-relative thumbnail-item"
                  [class.opacity-50]="i !== currentCarouselIndex"
                  (click)="slickModal.slickGoTo(i)"
                >
                  <img
                    [src]="getImageUrl(image.gambar)"
                    class="img-fluid rounded shadow-sm"
                    [alt]="boat?.nama_kapal"
                  />
                  <div
                    *ngIf="i === currentCarouselIndex"
                    class="position-absolute top-0 start-0 w-100 h-100 border border-2 border-light rounded"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="priceModal"
  tabindex="-1"
  aria-labelledby="priceModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="priceModalLabel">Price Breakdown</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body text-center">
        <img
          *ngIf="imageSrc; else noData"
          [src]="getPriceUrl(imageSrc)"
          class="img-fluid"
          alt="Price Breakdown"
        />
        <ng-template #noData>
          <p>No data available</p>
        </ng-template>
      </div>
    </div>
  </div>
</div>
